import {Injectable, EventEmitter} from "@angular/core";
import * as _ from 'lodash';
import { VEHICLE_APPLICANT, VEHICLE_LOAN, VEHICLE_FINANCINGProcessing_type, VEHICLE_FINANCINGValue_type, VEHICLE_FINANCINGCommercial_title } from 'src/models/vehicle_loan.model';
import { base_phone_country_alpha2, base_employee_of_lender_types, XPRESS_APPLICANT, XPRESS_LOAN, XPRESS_ACCOUNT_TYPESACCOUNT_TYPETerm_type, XPRESS_FUNDING_SOURCESFUNDING_SOURCEFunding_type, account_type } from 'src/models/xpress_loan.model';
import { BASE_APPLICANTDeclined_answer_race_gender, CREDITCARD_APPLICANT, CREDITCARD_LOAN } from 'src/models/creditcard_loan.model';
import { PERSONAL_APPLICANT, PERSONAL_LOAN } from 'src/models/personal_loan.model';
import { FinalPageEnum } from 'src/models/common.model';
import { LoanTypeEnum } from 'src/models/loan-type.enum';
import { ApiService } from './api.service';
import { ApplicantLoanComponent } from 'src/app/applicant-loan/applicant-loan.component';
import { FinalPageComponent } from "src/components/final-page/final-page.component";
import * as moment from "moment";



@Injectable(
    {
        providedIn: "root"
    }
)
export class LoanAppService {


    constructor(private apiService: ApiService)    {

    }





    fillOtherLoans(xpressLoan, vehicleLoan, personalLoan, creditCardLoan){

      //init ssn
      if (xpressLoan.APPLICANTS.length > 0) {
        const ssn = _.cloneDeep(xpressLoan.APPLICANTS[0].ssn); 
        xpressLoan.APPLICANTS[0].ssn = ssn ? ssn.replace(/\D/g, "") : "";

        if(creditCardLoan){
          creditCardLoan.APPLICANTS.APPLICANT[0].ssn = xpressLoan.APPLICANTS[0].ssn;
        }
        if(vehicleLoan){
          vehicleLoan.APPLICANTS.APPLICANT[0].ssn =  xpressLoan.APPLICANTS[0].ssn;
        }
        if(personalLoan){
          personalLoan.APPLICANTS.APPLICANT[0].ssn = xpressLoan.APPLICANTS[0].ssn;
        }

        if(xpressLoan.APPLICANTS[0].SPOUSE){
          const jointSSn =  _.cloneDeep(xpressLoan.APPLICANTS[0].SPOUSE.ssn);
          xpressLoan.APPLICANTS[0].SPOUSE.ssn = jointSSn ? jointSSn.replace(/\D/g, "") : "";

          if ( vehicleLoan?.APPLICANTS?.APPLICANT[0]?.SPOUSE) {
            vehicleLoan.APPLICANTS.APPLICANT[0].SPOUSE.ssn = xpressLoan.APPLICANTS[0].SPOUSE.ssn ;
          }
          if(personalLoan?.APPLICANTS?.APPLICANT[0]?.SPOUSE){
            personalLoan.APPLICANTS.APPLICANT[0].SPOUSE.ssn = xpressLoan.APPLICANTS[0].SPOUSE.ssn;
          }
          if (creditCardLoan.APPLICANTS.APPLICANT[0]?.SPOUSE) {
            creditCardLoan.APPLICANTS.APPLICANT[0].SPOUSE.ssn = xpressLoan.APPLICANTS[0].SPOUSE.ssn;
          }
        }
        
      }

      var commonFields = ['CUSTOM_QUESTIONS'];
      _.each(commonFields, f => {
        try {
          if (xpressLoan) {
            xpressLoan[f] = creditCardLoan?.[f];
          }
          if (vehicleLoan) {
            vehicleLoan[f] = creditCardLoan?.[f];
          }
          if (personalLoan) {
            personalLoan[f] = creditCardLoan?.[f];
          }
        } catch (ex) {
          console.log("commonFields ex", ex)
        }
      })
	  

      }

      submitDecisionLoan(loanType, submitHistoryId, creditCardLoan, vehicleLoan, personalLoan) {
        var data;
        switch (loanType) {
          case LoanTypeEnum.CC:
            data = creditCardLoan;
            break;
          case LoanTypeEnum.VL:
            data = vehicleLoan;
            break;
          case LoanTypeEnum.PL:
            data = personalLoan;
            break;
        }
        return this.apiService.submitDecisionLoan(loanType, submitHistoryId, '',data)
    }

    updateDecisionLoan(loanType, creditCardLoan, vehicleLoan, personalLoan,  soResponses:any, submitHistoryId, loanId ) {
      var data;
      switch (loanType) {
        case LoanTypeEnum.CC:
          data = creditCardLoan;
          break;
        case LoanTypeEnum.VL:
          data = vehicleLoan;
          break;
        case LoanTypeEnum.PL:
          data = personalLoan;
          break;
      }
      return this.apiService.updateDecisionLoan(data,soResponses, submitHistoryId, loanId);
    }
    
    initVehicleLoan(vehicleLoan){ 
        vehicleLoan.VEHICLES.VEHICLE= [{
          mileage:"0" ,
          vehicle_sales_price:0 ,
          vehicle_value:0 ,
          vehicle_value_type:"RETAIL" ,
          is_rebuilt_restored:BASE_APPLICANTDeclined_answer_race_gender.Y ,
          processing_type:VEHICLE_FINANCINGProcessing_type.MPLM ,
          vehicle_options:"" ,
          value_type:VEHICLE_FINANCINGValue_type.NONE,
          vin:"N/A",
            year:"0" ,
            make:"",
              nada_info:"", 
              commercial_title: VEHICLE_FINANCINGCommercial_title.NONE
        } as any];
    }


    


}